/* =============================================================================
   Mercer St. — Global JS (Phase 2)
   ============================================================================= */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Utility: format money — reads Shopify's money_format
  // ---------------------------------------------------------------------------
  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '¥{{amount_no_decimals}}';
    var amount = Math.round(cents / 100);
    return format
      .replace('{{amount}}', amount.toFixed(2))
      .replace('{{amount_no_decimals}}', amount.toLocaleString())
      .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amount.toLocaleString().replace('.', ','));
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Catalog mode: online purchasing disabled. Skip cart-drawer + add-to-cart wiring.
  var CATALOG_MODE = window.MercerCatalogMode === true;

  // ---------------------------------------------------------------------------
  // Mobile Navigation
  // ---------------------------------------------------------------------------
  var toggleBtn = document.getElementById('mobile-nav-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var closeBtn  = document.getElementById('mobile-nav-close');

  if (toggleBtn && mobileNav) {
    toggleBtn.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      mobileNav.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      toggleBtn.setAttribute('aria-expanded', 'true');
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeFilterDrawer();
      closeCartDrawer();
    }
  });

  // ---------------------------------------------------------------------------
  // AJAX Cart Drawer
  // ---------------------------------------------------------------------------
  var cartDrawer     = document.getElementById('cart-drawer');
  var cartOverlay    = document.getElementById('cart-drawer-overlay');
  var cartBody       = document.getElementById('cart-drawer-body');
  var cartSubtotalEl = document.getElementById('cart-drawer-subtotal');
  var cartLoading    = document.getElementById('cart-drawer-loading');
  var cartCountEls   = document.querySelectorAll('[data-cart-count]');
  var cartToast      = document.getElementById('cart-toast');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  var cartCloseBtn = document.getElementById('cart-drawer-close');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);

  // Intercept all /cart links to open drawer — DISABLED in catalog mode so the
  // cart link (if any) navigates normally to the catalog-notice cart page.
  if (!CATALOG_MODE) {
    document.querySelectorAll('a[href="/cart"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  function setCartLoading(on) {
    if (cartLoading) cartLoading.classList.toggle('is-active', on);
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  function fetchCart() {
    setCartLoading(true);
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function (e) { console.error('Cart fetch:', e); })
      .finally(function () { setCartLoading(false); });
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn" id="cart-continue">Continue Shopping</a>' +
        '</div>';
      var contBtn = document.getElementById('cart-continue');
      if (contBtn) contBtn.addEventListener('click', closeCartDrawer);
      if (cartSubtotalEl) cartSubtotalEl.textContent = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.\w+)$/, '_120x160$1')
        : null;
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escHtml(item.title) + '" loading="lazy">'
        : '<div style="background:var(--ms-bg2);width:100%;height:100%"></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item__variant">' + escHtml(item.variant_title) + '</p>' : '';

      html +=
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-item__image">' + imgHtml + '</a>' +
          '<div class="cart-item__details">' +
            '<a href="' + item.url + '" class="cart-item__title">' + escHtml(item.product_title) + '</a>' +
            variantHtml +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-action="decrement" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>' +
              '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-action="increment" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:0.5rem;">' +
            '<p class="cart-item__price">' + formatMoney(item.line_price) + '</p>' +
            '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>';
    });

    cartBody.innerHTML = html;
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);

    // Qty buttons
    cartBody.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.qty, 10);
        var newQty = btn.dataset.action === 'increment' ? qty + 1 : qty - 1;
        updateCartItem(btn.dataset.key, Math.max(0, newQty));
      });
    });

    // Remove buttons
    cartBody.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    setCartLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); updateCartCount(cart.item_count); })
      .catch(function (e) { console.error('Cart change:', e); })
      .finally(function () { setCartLoading(false); });
  }

  function showCartToast(msg) {
    if (!cartToast) return;
    cartToast.textContent = msg || 'Added to cart';
    cartToast.classList.add('is-visible');
    setTimeout(function () { cartToast.classList.remove('is-visible'); }, 2500);
  }

  // AJAX add-to-cart — DISABLED in catalog mode (no add-to-cart form is rendered,
  // but guard anyway so any stray form cannot submit to the cart).
  if (!CATALOG_MODE) {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var origText = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description); });
            return r.json();
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = origText; }
            showCartToast('Added to cart');
            openCartDrawer();
          })
          .catch(function (err) {
            console.error('Add to cart:', err);
            if (btn) { btn.disabled = false; btn.textContent = origText; }
            alert(err.message || 'Could not add to cart. Please try again.');
          });
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Product Gallery thumbnails
  // ---------------------------------------------------------------------------
  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.mercerGallery) return;
      var track = gallery.querySelector('.product-gallery__track');
      var slides = Array.from(gallery.querySelectorAll('.product-gallery__slide'));
      if (!track || !slides.length) return;
      var thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));
      var previous = gallery.querySelector('[data-gallery-previous]');
      var next = gallery.querySelector('[data-gallery-next]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      var status = gallery.querySelector('[data-gallery-status]');
      var active = Math.max(0, slides.findIndex(function (slide) {
        return slide.dataset.imageId === gallery.dataset.initialImage;
      }));
      var target = active;
      var settleTimer;
      var frame;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function update(index, announce) {
        active = index;
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
        if (announce && status) status.textContent = slides[index].getAttribute('aria-label');
      }
      function goTo(index, instant) {
        target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: target * track.clientWidth, behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
        if (instant) update(target, false);
      }
      function nearest() {
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      }
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { goTo(index, false); });
      });
      if (previous) previous.addEventListener('click', function () { goTo(target - 1, false); });
      if (next) next.addEventListener('click', function () { goTo(target + 1, false); });
      track.addEventListener('scroll', function () {
        if (!frame) frame = requestAnimationFrame(function () {
          update(nearest(), false);
          frame = null;
        });
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () { target = nearest(); update(target, true); }, 160);
      }, { passive: true });
      track.addEventListener('keydown', function (event) {
        var index;
        if (event.key === 'ArrowLeft') index = target - 1;
        else if (event.key === 'ArrowRight') index = target + 1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = slides.length - 1;
        else return;
        event.preventDefault();
        goTo(index, false);
      });
      var width = track.clientWidth;
      var observer = new ResizeObserver(function () {
        if (track.clientWidth && track.clientWidth !== width) {
          width = track.clientWidth;
          goTo(active, true);
        }
      });
      observer.observe(track);
      gallery.mercerGallery = {
        selectImage: function (id) {
          var index = slides.findIndex(function (slide) { return slide.dataset.imageId === String(id); });
          if (index !== -1) goTo(index, false);
        },
        destroy: function () {
          observer.disconnect();
          clearTimeout(settleTimer);
          if (frame) cancelAnimationFrame(frame);
        }
      };
      goTo(active, true);
      [previous, next, counter].forEach(function (element) { if (element) element.hidden = false; });
    });
  }
  initProductGalleries();
  document.addEventListener('shopify:section:load', initProductGalleries);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.mercerGallery) gallery.mercerGallery.destroy();
    });
  });

  // ---------------------------------------------------------------------------
  // Variant selector (reads JSON from inline script tags)
  // ---------------------------------------------------------------------------
  window.updateVariant = function (input) {
    var name = input.name;
    // Update visual state
    document.querySelectorAll('[name="' + name + '"]').forEach(function (radio) {
      var label = radio.closest('label');
      if (!label) return;
      var sw  = label.querySelector('.product-form__swatch');
      var sz  = label.querySelector('.product-form__size-btn');
      if (sw) sw.classList.toggle('is-selected', radio.checked);
      if (sz) sz.classList.toggle('is-selected', radio.checked);
    });

    var variantsEl = document.getElementById('product-variants-data');
    var optionsEl  = document.getElementById('product-options-data');
    if (!variantsEl || !optionsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var options  = JSON.parse(optionsEl.textContent);

    var selected = {};
    document.querySelectorAll('.product-form__options input[type="radio"]:checked').forEach(function (r) {
      selected[r.name] = r.value;
    });

    var variant = variants.find(function (v) {
      return v.options.every(function (opt, i) { return selected[options[i]] === opt; });
    });

    if (!variant) return;

    var idInput = document.getElementById('ProductVariantId');
    if (idInput) idInput.value = variant.id;

    var priceEl = document.getElementById('ProductPrice');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var addBtn = document.getElementById('AddToCartButton');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (variant.featured_image) {
      var productGallery = document.querySelector('[data-product-gallery]');
      if (productGallery && productGallery.mercerGallery) {
        productGallery.mercerGallery.selectImage(variant.featured_image.id);
      }
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  };

  // ---------------------------------------------------------------------------
  // Filter Drawer (mobile)
  // ---------------------------------------------------------------------------
  var filterDrawer        = document.getElementById('filter-drawer');
  var filterDrawerOverlay = document.getElementById('filter-drawer-overlay');
  var filterOpenBtn       = document.getElementById('filter-open-btn');
  var filterCloseBtn      = document.getElementById('filter-drawer-close');

  if (filterOpenBtn && filterDrawer) {
    filterOpenBtn.addEventListener('click', function () {
      filterDrawer.classList.add('is-open');
      if (filterDrawerOverlay) filterDrawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterDrawer);
  if (filterDrawerOverlay) filterDrawerOverlay.addEventListener('click', closeFilterDrawer);

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    if (filterDrawerOverlay) filterDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Auto-submit filter form on checkbox/select change
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });
    var sortSel = form.querySelector('.sort-select');
    if (sortSel) sortSel.addEventListener('change', function () { form.submit(); });
  });

  // ---------------------------------------------------------------------------
  // Accordion — expand on desktop by default
  // ---------------------------------------------------------------------------
  function setAccordionDefaults() {
    var isDesktop = window.innerWidth > 1024;
    document.querySelectorAll('.accordion details').forEach(function (d) {
      if (isDesktop && !d.hasAttribute('data-mobile-only')) d.setAttribute('open', '');
    });
  }

  setAccordionDefaults();

})();
/* =============================================================================
   Favourites / Wishlist (Phase 1 — localStorage)
   ============================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'mercer_favourites_v1';

  function readFavs() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeFavs(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      console.error('Favourites save failed:', e);
    }
  }

  function isFav(handle) {
    return readFavs().some(function (f) { return f.handle === handle; });
  }

  function addFav(item) {
    var favs = readFavs();
    if (favs.some(function (f) { return f.handle === item.handle; })) return;
    favs.push(item);
    writeFavs(favs);
    updateHeaderCount();
  }

  function removeFav(handle) {
    var favs = readFavs().filter(function (f) { return f.handle !== handle; });
    writeFavs(favs);
    updateHeaderCount();
  }

  function toggleFav(item) {
    if (isFav(item.handle)) {
      removeFav(item.handle);
      return false;
    }
    addFav(item);
    return true;
  }

  // Build an item object from a fav button's data attributes
  function itemFromButton(btn) {
    return {
      handle:   btn.dataset.favHandle || '',
      title:    btn.dataset.favTitle || '',
      url:      btn.dataset.favUrl || '',
      image:    btn.dataset.favImage || '',
      price:    btn.dataset.favPrice || '',
      material: btn.dataset.favMaterial || ''
    };
  }

  function setButtonState(btn, saved) {
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('.fav-btn__label');
    if (label) {
      label.textContent = saved
        ? (btn.dataset.favLabelSaved || 'Saved')
        : (btn.dataset.favLabelDefault || 'Save to favourites');
    }
    var aria = saved
      ? (btn.dataset.favAriaSaved || 'Remove from favourites')
      : (btn.dataset.favAriaDefault || 'Save to favourites');
    btn.setAttribute('aria-label', aria);
  }

  // Initialise every fav button on the page
  function initButtons(scope) {
    var root = scope || document;
    root.querySelectorAll('.fav-btn[data-fav-handle]').forEach(function (btn) {
      if (btn.dataset.favBound === '1') return;
      btn.dataset.favBound = '1';

      setButtonState(btn, isFav(btn.dataset.favHandle));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var saved = toggleFav(itemFromButton(btn));
        // Sync all buttons for the same product on the page
        document.querySelectorAll('.fav-btn[data-fav-handle="' + CSS.escape(btn.dataset.favHandle) + '"]')
          .forEach(function (b) { setButtonState(b, saved); });
        // If we're on the favourites page, re-render
        if (document.getElementById('favourites-root')) renderFavouritesPage();
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Header count
  // ---------------------------------------------------------------------------
  function updateHeaderCount() {
    var n = readFavs().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n > 0 ? '(' + n + ')' : '';
    });
  }

  // ---------------------------------------------------------------------------
  // Favourites page renderer
  // ---------------------------------------------------------------------------
  function escHtmlLocal(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderFavouritesPage() {
    var root = document.getElementById('favourites-root');
    if (!root) return;

    var favs = readFavs();
    var emptyCopy = root.dataset.emptyCopy || 'You have not saved any pieces yet.';
    var ctaLabel  = root.dataset.ctaLabel  || 'Continue shopping';
    var ctaUrl    = root.dataset.ctaUrl    || '/collections/all';
    var removeLabel = root.dataset.removeLabel || 'Remove';

    if (!favs.length) {
      root.innerHTML =
        '<div class="favourites-empty">' +
          '<p>' + escHtmlLocal(emptyCopy) + '</p>' +
          '<a href="' + escHtmlLocal(ctaUrl) + '" class="btn">' + escHtmlLocal(ctaLabel) + '</a>' +
        '</div>';
      return;
    }

    var html = '<div class="product-grid">';
    favs.forEach(function (f) {
      var imgHtml = f.image
        ? '<img src="' + escHtmlLocal(f.image) + '" alt="' + escHtmlLocal((f.handle === 'golden-cashmere-100-inner-leggings-hong-kong-exclusive-longer-length' || f.handle === 'golden-cashmere-inner-pants-ericas-edition') ? 'Golden Cashmere Inner Pants' : f.title) + '" loading="lazy">'
        : '<div style="background:var(--ms-bg2);width:100%;height:100%"></div>';
      var materialHtml = f.material
        ? '<p class="product-card__material">' + escHtmlLocal(f.material) + '</p>' : '';
      html +=
        '<article class="product-card">' +
          '<a href="' + escHtmlLocal(f.url) + '" class="product-card__image-wrap" aria-label="' + escHtmlLocal((f.handle === 'golden-cashmere-100-inner-leggings-hong-kong-exclusive-longer-length' || f.handle === 'golden-cashmere-inner-pants-ericas-edition') ? 'Golden Cashmere Inner Pants' : f.title) + '">' +
            imgHtml +
          '</a>' +
          '<div class="product-card__info">' +
            materialHtml +
            '<a href="' + escHtmlLocal(f.url) + '"><p class="product-card__title">' + escHtmlLocal((f.handle === 'golden-cashmere-100-inner-leggings-hong-kong-exclusive-longer-length' || f.handle === 'golden-cashmere-inner-pants-ericas-edition') ? 'Golden Cashmere Inner Pants' : f.title) + '</p></a>' +
            (f.price ? '<p class="product-card__price">' + escHtmlLocal(f.price) + '</p>' : '') +
            '<button type="button" class="fav-card__remove" data-fav-remove="' + escHtmlLocal(f.handle) + '" aria-label="' + escHtmlLocal(removeLabel + ' ' + f.title) + '">' + escHtmlLocal(removeLabel) + '</button>' +
          '</div>' +
        '</article>';
    });
    html += '</div>';
    root.innerHTML = html;

    root.querySelectorAll('[data-fav-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFav(btn.dataset.favRemove);
        renderFavouritesPage();
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  initButtons();
  updateHeaderCount();
  renderFavouritesPage();

  // Expose a tiny API in case other scripts add cards dynamically
  window.MercerFavourites = {
    init: initButtons,
    refresh: function () { updateHeaderCount(); renderFavouritesPage(); }
  };
})();

/* =============================================================================
   Recently/most-viewed by dwell time (Phase 1 — localStorage)
   Records visible time per product on product pages, ranked for My Page.
   Known limits: per-device only (no cross-device sync); product-page views
   only (not collections); idle-tab time is paused via Page Visibility but a
   foreground tab left open still accrues; new visitors have no data (My Page
   falls back to a server-rendered newest grid).
   ============================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'mercer_dwell_v1';
  var MAX_ENTRIES = 24;        // cap stored products
  var MAX_PER_VISIT_MS = 600000; // clamp a single visit's contribution to 10 min

  // Read the product metadata blob emitted on product pages.
  var dataEl = document.getElementById('mercer-dwell-product');
  if (!dataEl) return; // not a product page — nothing to track

  var product;
  try {
    product = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!product || !product.handle) return;

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var obj = raw ? JSON.parse(raw) : {};
      return (obj && typeof obj === 'object') ? obj : {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(obj) {
    try {
      // Trim to the MAX_ENTRIES most-dwelt before saving.
      var entries = Object.keys(obj).map(function (k) { return [k, obj[k]]; });
      entries.sort(function (a, b) { return (b[1].ms || 0) - (a[1].ms || 0); });
      var trimmed = {};
      entries.slice(0, MAX_ENTRIES).forEach(function (pair) { trimmed[pair[0]] = pair[1]; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) { /* quota or disabled — ignore */ }
  }

  // Visibility-aware accumulation
  var accrued = 0;            // ms accrued this visit
  var lastStart = (document.visibilityState === 'visible') ? Date.now() : null;

  function pause() {
    if (lastStart != null) {
      accrued += Date.now() - lastStart;
      lastStart = null;
    }
  }
  function resume() {
    if (lastStart == null) lastStart = Date.now();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resume();
    else { pause(); flush(); }
  });

  var flushed = false;
  function flush() {
    // Fold any running interval into accrued without resetting wall clock incorrectly
    if (lastStart != null) {
      accrued += Date.now() - lastStart;
      lastStart = (document.visibilityState === 'visible') ? Date.now() : null;
    }
    if (accrued <= 0) return;

    var add = Math.min(accrued, MAX_PER_VISIT_MS);
    accrued = 0; // reset so we don't double-count across multiple flushes

    var store = readStore();
    var prev = store[product.handle] && store[product.handle].ms ? store[product.handle].ms : 0;
    store[product.handle] = {
      ms: prev + add,
      title: product.title || '',
      url: product.url || '',
      image: product.image || '',
      price: product.price || '',
      material: product.material || '',
      t: Date.now()
    };
    writeStore(store);
  }

  // Flush on the page going away. pagehide is the most reliable on mobile Safari.
  window.addEventListener('pagehide', flush);
  window.addEventListener('beforeunload', flush);
  // Periodic flush so very long single sessions still persist something.
  setInterval(function () { flush(); }, 30000);
})();


